import {createContext, useContext} from 'react';

// Корень экрана матча (div.App.game-ui в GameContent). Модалки, которым нужно
// вырваться из стекового контекста своей панели (список зрителей, перехват
// бота — обе живут в боковом меню), рендерятся порталом сюда, а не в body:
// вне корня стили дизайн-системы матча и ее токены не действуют
export const GameUiRootContext = createContext(null);

/**
 * Куда рендерить портал модалки матча: корень .game-ui, а вне экрана матча
 * (тесты, страницы меню) — body
 * @returns {HTMLElement}
 */
export const useGameUiPortalTarget = () => useContext(GameUiRootContext) || document.body;
